import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { homeForRole } from "@/lib/api";

const Loading = () => (
  <div className="flex min-h-[60vh] items-center justify-center">
    <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
  </div>
);

export const ProtectedRoute = ({ children, roles, requireOnboarding = false }) => {
  const { user, ready } = useAuth();
  const location = useLocation();

  if (!ready || user === null) return <Loading />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homeForRole(user.role)} replace />;
  if (requireOnboarding && user.role === "STUDENT" && !user.onboardingCompleted) {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
};
